import React, { createContext, useContext, useState } from 'react';
import { toast as sonnerToast, Toaster } from 'sonner';

const ToasterContext = createContext();

export const useToaster = () => {
  const context = useContext(ToasterContext);
  if (!context) {
    throw new Error('useToaster deve ser usado dentro de um ToasterProvider');
  }
  return context;
};

export const ToasterProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const toast = {
    success: (message, options = {}) => {
      sonnerToast.success(message, options);
    },
    error: (message, options = {}) => {
      sonnerToast.error(message, options);
    },
    info: (message, options = {}) => {
      sonnerToast.info(message, options);
    },
    warning: (message, options = {}) => {
      sonnerToast.warning(message, options);
    },
  };

  const value = {
    toast,
    toasts,
  };

  return (
    <ToasterContext.Provider value={value}>
      {children}
      <Toaster 
        position="top-right"
        expand={true}
        richColors={true}
        closeButton={true}
      />
    </ToasterContext.Provider>
  );
};
